import React from 'react';
// import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import { STATE } from 'services/3dviewer/moving-controls/synchronizeController';
import store from 'store';
import classNames from "classnames";
import { ReactComponent as Rectangle } from 'asset/image/rectangle.svg';
import { ReactComponent as FloorPlan_icon } from 'asset/image/floorPlan_icon.svg';
import { ReactComponent as Floorplan } from 'asset/image/floorplan.svg';
import { ReactComponent as MiniMapClose_icon } from 'asset/image/miniMapClose_icon.svg';
import topView_icon from 'asset/image/topView_icon.svg';
import back from 'asset/image/back.svg';
import hide from 'asset/image/hide.svg';
import FloorPlaneCanvas from '../floorplan-canvas';
import './css/MenuStyle.scss';
import { RectAreaLight } from 'three';

class ViewChangeMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayMenu: false,
      displayBack: false,
      openMenu: true,
      hoverMenu: false,
      openMapColor: true,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.hoverMenu = this.hoverMenu.bind(this);
    this.viewChange = this.viewChange.bind(this);
    this.openMiniMap = this.openMiniMap.bind(this);
    this.closeMiniMap = this.closeMiniMap.bind(this);
  }

  componentDidMount () {
    this.unsubscribe = store.subscribe(this.viewChange); // add moniter changes from store and set listener
    this.viewChange();
    this.props.parent.setState({
      isNotFirst: true,
    });
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.type != this.props.type) {
      this.forceUpdate();
    }

    if (prevProps.display != this.props.display) {
      this.forceUpdate();
    }
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  toggleMenu () {
    this.setState({
      openMenu: !this.state.openMenu,
    });
  }

  hoverMenu () {
    this.setState({
      hoverMenu: !this.state.hoverMenu,
    });
  }

  openMiniMap () {
    this.setState({
      openMenu: true,
      openMapColor: true,
    });
  }

  closeMiniMap () {
    this.setState({
      openMenu: false,
      openMapColor: false,
    });
  }

  viewChange () {
    const { viewButton, viewVariable } = store.getState();
    const { viewState } = viewButton;

    if (viewVariable.isCameraMoving) {
      this.setState({
        displayMenu: false,
        displayBack: false,
      });
    } else {
      this.setState({
        displayMenu: viewState === STATE.FPVIEW,
        displayBack: !(viewState === STATE.FPVIEW),
      });
    }
  }

  render () {
    const { viewButton } = store.getState();
    const { goDown, goUp, toOrthographics } = viewButton;
    const { displayMenu, displayBack, openMenu, hoverMenu } = this.state;
    const { t } = this.props;

    let rwdPostfix = this.props.type == 'Mobile' ? '-mobile' : '';

    const menuIconStyle = {
      transform: openMenu ? 'rotate(0.25turn)' : 'rotate(-0.25turn)',
      WebkitTransform: openMenu ? 'rotate(0.25turn)' : 'rotate(-0.25turn)',
    };

    const menuOpenStyle =
      this.props.type == 'Mobile'
        ? {
          display: displayMenu ? '' : 'none',
          transform: openMenu ? 'translateX(0%)' : 'translateX(-100%)',
          WebkitTransform: openMenu ? 'translateX(0%)' : 'translateX(-100%)',
        }
        : {
          display: displayMenu ? '' : 'none',
          transform: openMenu
            ? 'translateY(0px)'
            : hoverMenu
              ? 'translateY(220px)'
              : 'translateY(345px)',
          WebkitTransform: openMenu
            ? 'translateY(0px)'
            : hoverMenu
              ? 'translateY(220px)'
              : 'translateY(345px)',
        };

    const menuOpenStyle1 =
      this.props.type == 'Mobile'
        ? {
          visibility: displayMenu ? 'visible' : 'hidden',
          //transform: openMenu ? 'translateX(0%)' : 'translateX(-100%)',
          //WebkitTransform: openMenu ? 'translateX(0%)' : 'translateX(-100%)'
        }
        : {
          visibility: displayMenu ? 'visible' : 'hidden',
        };

    const menuBoardStyle =
      this.props.type == 'Mobile'
        ? {
          display: displayMenu ? '' : 'none',
          transform: openMenu ? 'translateX(-100%)' : 'translateX(0%)',
          WebkitTransform: openMenu ? 'translateX(-100%)' : 'translateX(0%)',
        }
        : {
          display: displayMenu ? '' : 'none',
          transform: openMenu
            ? 'translateY(0px)'
            : hoverMenu
              ? 'translateY(345px)'
              : 'translateY(339px)',
          WebkitTransform: openMenu
            ? 'translateY(0px)'
            : hoverMenu
              ? 'translateY(345px)'
              : 'translateY(339px)',
        };

    const containerDisplay = this.props.display
      ? {
        display: '',
      }
      : {
        display: 'none',
      };
    let togglebuttonStatus = '';
    if (openMenu) {
      togglebuttonStatus = ' Open';
    }

    return this.props.type == 'PC' ? (
      <div className="view-menu-container" style={containerDisplay}>
        <button className='fpview-button' style={{ visibility: displayBack ? 'visible' : 'hidden' }} type="button" onClick={goDown}>
          <img src={back} alt="back" />
        </button>
        <div
          className={
            'floorplan-topview-container1' + rwdPostfix + togglebuttonStatus
          }
          style={menuOpenStyle1}
        >
          <div
            className={
              'floorplan-topview-div' + rwdPostfix + togglebuttonStatus
            }
          >
            <button
              className={'menu-toggle-button' + rwdPostfix + togglebuttonStatus}
              type="button"
              onClick={this.toggleMenu}
              onMouseEnter={this.hoverMenu}
              onMouseLeave={this.hoverMenu}
            >
              <div className="title-wrap">
                <FloorPlan_icon className="icon-3d-view" alt="floorPlan_icon" />
                <span className="buttonText">
                  &nbsp;
                  {t('viewMode.floorPlan')}
                </span>
              </div>
              <img src={hide} alt="hide" style={menuIconStyle} />
            </button>

            {openMenu && (
              <div className={'floorplan-button' + rwdPostfix} type="button">
                <FloorPlaneCanvas
                  open={displayMenu && openMenu}
                  viewerCameraController={this.props.viewerCameraController}
                  objectManager={this.props.objectManager}
                />
              </div>
            )}
          </div>

          <div
            style={{
              display: 'flex',
              width: '100%',
              borderRadius: '40px',
              marginTop: '7px',
              background: 'rgba(0, 0, 0, 0.5)',
            }}
          >
            <button
              // className={'topview-button' + rwdPostfix}
              className={classNames('topview-button', rwdPostfix, 'birdview-btn')}
              style={{ borderRadius: '40px' }}
              type="button"
              hidden={false}
              onClick={() => {
                toOrthographics();
              }}
            >
              <Floorplan className="icon-3d-view" alt="topView_icon" />
              {/* <img src={topView_icon} alt="topView_icon"/> */}
              {/* <MiniMap className="icon-3d-view" alt="miniMap" /> */}
              {/* <i className="icon-3d-view"> </i> */}
              <span className="buttonText">
                {/* &nbsp; */}
                {t('viewMode.birdView')}
              </span>
            </button>

            <button
              // className={'topview-button' + rwdPostfix}
              className={classNames('topview-button', rwdPostfix, 'dollhouse-btn')}
              style={{ borderRadius: '40px' }}
              type="button"
              hidden={false}
              onClick={() => {
                goUp();
              }}
            >
              <Rectangle className="icon-3d-view" alt="rectangle" />
              {/* <i className="icon-3d-view"> </i> */}
              <span className="buttonText">
                {/* &nbsp; */}
                {t('viewMode.dollhouse')}
              </span>
            </button>
          </div>
        </div>
      </div>
    ) : (
      <>
        {displayBack && (
          <button
            className={'fpview-button-mobile'}
            type="button"
            onClick={goDown}
          >
            <img src={back} alt="back" />
          </button>
        )}
        {this.props.isFPview && (
          <div
            className={
              'floorplan-topview-container1' + rwdPostfix + togglebuttonStatus
            }
          >
            <div
              className={
                'floorplan-topview-div' + rwdPostfix + togglebuttonStatus
              }
            >
              {openMenu && (
                <div className={'floorplan-button' + rwdPostfix} type="button">
                  <FloorPlaneCanvas
                    open={displayMenu && openMenu}
                    viewerCameraController={this.props.viewerCameraController}
                    objectManager={this.props.objectManager}
                  />
                </div>
              )}
              {openMenu && (
                <div
                  className={'floorplan-close-button' + rwdPostfix}
                  onClick={this.closeMiniMap}
                >
                  <MiniMapClose_icon
                    className="icon-minimap-close"
                    alt="icon-minimap-close"
                  />
                </div>
              )}
            </div>

            <div className="buttonBar">
              <button
                className={'topview-button' + rwdPostfix}
                type="button"
                onClick={this.openMiniMap}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 16 16"
                  fill={this.state.openMapColor ? '#6FEDD6' : '#CECCCA'}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M14.75 0.125H1.25C0.63125 0.125 0.125 0.63125 0.125 1.25V14.75C0.125 15.3687 0.63125 15.875 1.25 15.875H9.6875V14.75C9.6875 13.175 10.925 11.9375 12.5 11.9375V10.8125C10.3062 10.8125 8.5625 12.5562 8.5625 14.75H6.875V12.5H5.75V14.75H1.25V1.25H5.75V9.125H6.875V6.3125H9.125V5.1875H6.875V1.25H14.75V5.1875H12.5V6.3125H14.75V14.75H12.5V15.875H14.75C15.3687 15.875 15.875 15.3687 15.875 14.75V1.25C15.875 0.63125 15.3687 0.125 14.75 0.125Z" />
                </svg>
              </button>

              <button
                // className={'topview-button' + rwdPostfix}
                className={classNames('topview-button', rwdPostfix, 'dollhouse-btn')}

                style={{ borderRadius: '40px' }}
                type="button"
                hidden={false}
                onClick={() => {
                  console.log('3d view');
                  goUp();
                }}
              >
                <Rectangle className="icon-3d-view" alt="rectangle" />
              </button>

              <button
                // className={'topview-button' + rwdPostfix}
                className={classNames('topview-button', rwdPostfix, 'birdview-btn')}

                style={{ borderRadius: '40px' }}
                type="button"
                hidden={false}
                onClick={() => {
                  toOrthographics();
                }}
              >
                <Floorplan className="icon-3d-view" alt="topView_icon" />
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}
export default withTranslation()(ViewChangeMenu);
